import { clamp, isFiniteNumber } from './math.js';

/** 从参数 schema 生成默认参数对象。 */
export function defaultsFor(model) {
  const params = {};
  for (const field of model.schema) params[field.key] = field.default;
  return params;
}

/**
 * 参数护栏：把非数字、越界值修复为安全值。
 * 每一次修复都会留下可解释的记录，供教学 Agent 展示。
 * @returns {{ params: object, repairs: Array<{key:string, from:unknown, to:number, reason:string}> }}
 */
export function normalizeParams(model, input = {}) {
  const params = {};
  const repairs = [];
  for (const field of model.schema) {
    const raw = input[field.key];
    let value = raw;
    if (!isFiniteNumber(value)) {
      value = field.default;
      repairs.push({
        key: field.key,
        from: raw,
        to: value,
        reason: raw === undefined ? '参数缺失，使用默认值' : '参数不是有限数值，已回退默认值',
      });
    }
    if (value < field.min || value > field.max) {
      const next = clamp(value, field.min, field.max);
      repairs.push({
        key: field.key,
        from: value,
        to: next,
        reason: `参数越界（允许 ${field.min}–${field.max} ${field.unit ?? ''}），已自动夹紧`,
      });
      value = next;
    }
    params[field.key] = value;
  }
  if (typeof model.sanitizeParams === 'function') {
    const sanitized = model.sanitizeParams(params);
    for (const field of model.schema) {
      if (sanitized[field.key] !== params[field.key]) {
        repairs.push({
          key: field.key,
          from: params[field.key],
          to: sanitized[field.key],
          reason: '模型附加约束修正',
        });
      }
    }
    return { params: sanitized, repairs };
  }
  return { params, repairs };
}

export function formatParam(field, value) {
  const decimals = String(field.step).includes('.')
    ? Math.min(4, String(field.step).split('.')[1].length)
    : 0;
  return Number(value).toFixed(decimals);
}

export function paramField(model, key) {
  return model.schema.find((field) => field.key === key);
}

export function paramsEqual(a, b) {
  return Object.keys(a).every((key) => a[key] === b[key]);
}
